module.exports = {
      id: "youtube-plain-color-usage",
      viewBox: "0 0 30 21",
      url: __webpack_public_path__ + "svg-sprite-e76c2ea32079628f8a8c5156f1fd5f59.svg#youtube-plain-color",
      toString: function () {
        return this.url;
      }
    }